import React from 'react';
import PropTypes from 'prop-types';

import { DetailCell, HeightIcon, IconContainer } from './styled';

const t = {
  meters: 'm',
};

const VehicleContainerHeight = ({ container_height, className, ...props }) => (
  <DetailCell className={className} {...props}>
    {!!container_height && (
      <IconContainer>
        <HeightIcon /> {container_height} {t.meters}
      </IconContainer>
    )}
  </DetailCell>
);

VehicleContainerHeight.propTypes = {
  container_height: PropTypes.string,
  className: PropTypes.string,
};

export default VehicleContainerHeight;
